export default __webpack_public_path__ + "static/media/kitchen4-afterF-480w.f27d4b32.webp";